import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { useIntl } from 'react-intl';

import preview1 from 'src/assets/images/cameras/preview-1.png';
import preview2 from 'src/assets/images/cameras/preview-2.png';
import preview3 from 'src/assets/images/cameras/preview-3.png';
import preview4 from 'src/assets/images/cameras/preview-4.png';
import CameraTile from 'src/features/cameras/components/CameraTile';
import { dashboardMessages } from 'src/features/dashboard/utils/messages';
import GeneralMessageBlock from 'src/registry/components/blocks/GeneralMessageBlock';
import {
    SectionBlock,
    SectionBlockBody,
    SectionBlockHead,
    SectionBlockHeader,
    SectionBlockSeparator,
    SectionBlockTitle,
} from 'src/registry/components/blocks/SectionBlock';
import { Skeleton } from 'src/registry/ui/Skeleton';

import type { Camera } from 'src/features/cameras/types/camera';

type DashboardWidgetCamerasProps = {
    cameras?: Camera[];
    isLoadingCameras?: boolean;
    isErrorCameras?: boolean;
};

const images = [preview1, preview2, preview3, preview4];

function DashboardWidgetCameras({ cameras = [], isLoadingCameras, isErrorCameras }: DashboardWidgetCamerasProps) {
    const { formatMessage } = useIntl();

    return (
        <SectionBlock className="xs:min-w-96 flex-1 shrink-0">
            <SectionBlockHeader>
                <SectionBlockHead>
                    <SectionBlockTitle>{formatMessage(dashboardMessages.cameras)}</SectionBlockTitle>
                </SectionBlockHead>
            </SectionBlockHeader>
            <SectionBlockSeparator />
            <SectionBlockBody className="grid h-full grid-cols-2 gap-4 xl:flex xl:flex-row xl:gap-4 2xl:grid 2xl:grid-cols-2">
                {isLoadingCameras && (
                    <>
                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                    </>
                )}

                {isErrorCameras && (
                    <GeneralMessageBlock className="xs:col-span-2 py-12" variant="error" icon={faCircleExclamation} />
                )}

                {cameras.length == 0 && !isErrorCameras && !isLoadingCameras && (
                    <GeneralMessageBlock
                        className="xs:col-span-2 py-12"
                        title={formatMessage(dashboardMessages.noCameras)}
                        subtitle={formatMessage(dashboardMessages.noCamerasSubtitle)}
                        icon={faCircleExclamation}
                    />
                )}
                {cameras &&
                    cameras
                        ?.slice(0, 4)
                        .map((camera, index) => (
                            <CameraTile
                                preview={images[index]}
                                index={index}
                                camera={camera}
                                key={`${camera.id}-${index}`}
                            />
                        ))}
            </SectionBlockBody>
        </SectionBlock>
    );
}

export default DashboardWidgetCameras;
